/**
 * Harvest Help Needed — full article page for the "Harvest Help Needed"
 * sharing option under Urban Harvest.
 *
 * Route: /food-pulse/urban-harvest/harvest-help-needed
 */
import { HandHeart } from "lucide-react";
import UrbanHarvestArticleLayout, { UH_PALETTE } from "@/components/UrbanHarvestArticleLayout";

export default function FoodPulseUrbanHarvestHarvestHelp() {
  return (
    <UrbanHarvestArticleLayout
      slug="harvest-help-needed"
      title="Harvest Help Needed"
      subtitle="When Nature Produces More Than You Can Manage"
      icon={HandHeart}
      accent={UH_PALETTE.moss}
      body={[
        "Fruit trees don't wait for busy schedules. Gardens continue producing whether you're traveling, working long hours, recovering from an illness, or simply unable to harvest everything before it ripens.",
        "The Harvest Help Needed program connects homeowners with trusted volunteers and community harvesting teams who can help gather ripe fruits and vegetables before they are lost.",
        "After you submit a request, FoodPulse matches your harvest with nearby vetted volunteers or members of the FoodPulse Gleaning Corps based on location, availability, and the type of harvest required. Visits are coordinated in advance, and homeowners always choose whether to accept a match and when harvesting takes place.",
        "Once harvested, produce can be shared according to your preferences. Keep what you need, donate the rest, share with neighbors, or distribute it through participating community organizations.",
        "This program is especially valuable for seniors, people with disabilities, busy families, absentee homeowners, and anyone with large or difficult-to-harvest trees.",
      ]}
      pullquote="No harvest should be lost simply because one person can't pick it alone."
      closer="With a little help from the community, every backyard can become part of a healthier, more sustainable local food system where abundance is shared instead of wasted."
    />
  );
}
